import React, { Fragment } from 'react';
import propTypes from 'prop-types';
import { Link } from 'utils/store/thirdPartyConnectToCanvasStore';

/**
 * returns react component to render duplicate named components message
 * @param {object} props - props passed to this component
 * @returns {React.Component} a chip component
 */
const DuplicateComponentNamesMessage = ({ duplicateNamedComponents, visitComponent }) => (
  <Fragment>
    Different components can not have same names!:
    <div>
      {duplicateNamedComponents.map(comp => {
        if (!comp.Id) {
          return <div key={comp.ComponentName}>{comp.ComponentName}</div>;
        }
        return (
          <Link key={comp.Id} target="_blank" to={visitComponent(comp.Id, comp.Version)}>
            {comp.ComponentName}
          </Link>
        );
      })}
    </div>
  </Fragment>
);

DuplicateComponentNamesMessage.propTypes = {
  duplicateNamedComponents: propTypes.arrayOf(
    propTypes.shape({
      Id: propTypes.string,
      ComponentName: propTypes.string,
      Version: propTypes.string
    })
  ).isRequired,
  visitComponent: propTypes.func.isRequired
};

export default DuplicateComponentNamesMessage;
